module.exports = __webpack_public_path__ + "img/16.57cc4ee1.jpg";